// extracted by mini-css-extract-plugin
export default {"campaignSignpostHeader":"CampaignSignpost_campaignSignpostHeader__D76Jx"};